<template>
  <b-card
      title="کارشناسان تغذیه"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                  class="mb-1 ml-1 mr-auto"
                  variant="primary"
                  @click="showModal = true"
              >
                جدید
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
        >
          <template #cell(UserId)="data">
            <b-link
                :to="{ name: 'userDetail', params: { id: data.value }}"
                class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Name)="data">
            <span class="text-nowrap">
              <b-avatar
                  class="mr-1"
                  :src="data.item.Image"
              />
              {{ data.item.Name }} {{ data.item.Family }}
            </span>
          </template>

          <template #cell(IsActive)="data">
            <b-badge
                :variant="data.value ? 'success' : 'warning'"
            >
              {{ data.value ? 'فعال' : 'غیرفعال' }}
            </b-badge>
          </template>

          <template #cell(actions)="data">
            <div
                class="text-nowrap"
            >
              <feather-icon
                  icon="EditIcon"
                  size="16"
                  @click="edit(data.item)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>

        <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
        />
      </b-col>
    </b-row>
    <nutritionist-form
        :show.sync="showModal"
        :item="editingItem"
        @done="update"
    />
  </b-card>
</template>

<script>
import nutritionistForm from "@/views/menu/user/nutritionist/nutritionistForm.vue";
export default {
  name: 'Charges',
  components: { nutritionistForm },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      formLoading: false,
      showModal: false,
      filterOptions: {
        Page: 1,
        PerPage: 10,
      },
      fields: [
        {
          key: 'UserId',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Name',
          label: 'نام و نام خانوادگی',
        },
        {
          key: 'DegreeEducation',
          label: 'مدرک تحصیلی',
        },
        {
          key: 'NezamNum',
          label: 'شماره نظام پزشکی',
        },
        {
          key: 'IsActive',
          label: 'وضعیت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
      editingItem: null
    }
  },
  watch: {
    showModal(val) {
      if (!val) this.editingItem = null
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
          this.$api.nutritionist.getList, this.filterOptions,
      )
          .then(res => {
            this.totalRows = res.totalRow
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
    },
    edit(item) {
      this.editingItem = {
        UserId: item.UserId,
        NezamNum: item.NezamNum,
        DegreeEducation: item.DegreeEducation,
        IsActive: item.IsActive
      }
      this.showModal = true
    },
  },
}
</script>